/* RMS 2026-09-29 · mekanizma rozeti mobilde gorus alaninda acilir
   Gerekce ve olcum: src/rms/rozet-mobil-hareket.mjs
   Masaustunde ayraclar :hover ile aciliyor. Dokunmatikte hover olmadigi
   icin sabit duruyorlardi; burada ayni acilis kart ekrana girince
   tetikleniyor. Bir kez calisir, kaydirdikca tekrarlamaz. */
(function () {
  'use strict';
  if (!window.matchMedia || !window.IntersectionObserver) return;
  /* Yalnizca dokunmatikte. Faresi olan cihazda hover kurali zaten var;
     ikisi birden calisirsa ayraclar iki kez oynar. */
  if (!window.matchMedia('(hover:none)').matches) return;

  var SINIF = 'rms-gorundu';
  var gozlemci = new IntersectionObserver(function (girisler) {
    for (var i = 0; i < girisler.length; i++) {
      var g = girisler[i];
      if (!g.isIntersecting) continue;
      g.target.classList.add(SINIF);
      gozlemci.unobserve(g.target);      // bir kez yeter
    }
  }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });

  function tara() {
    var k = document.querySelectorAll('.product-item:not(.' + SINIF + ')');
    for (var i = 0; i < k.length; i++) {
      if (k[i].querySelector('.rms-badge')) gozlemci.observe(k[i]);
    }
  }

  function baslat() {
    tara();
    /* Sekmeli vitrin ve sonsuz kaydirma kart EKLIYOR; yeni kartlar da
       izlenmeli. */
    new MutationObserver(function () { tara(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
